import React from "react";
import ListenFeedSettingsContainer from "../../modules/GAListenFeedSettings/containers/ListenFeedSettingsContainer/ListenFeedSettingsContainer";

const GAListenFeedSettings = () => {
  return <ListenFeedSettingsContainer />;
};

export default GAListenFeedSettings;
